/* eslint-disable no-unused-vars */

import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import { Store } from '../../../store';
import { Inspector } from 'react-inspector';
import ArchiveDetails from '../ArchiveDetails/ArchiveDetails';
import MatchingTicketSection from '../MatchingTicketSection';
import WorkLog from '../../TicketDetailComponents/SubComponents/WorkLog';
import PositiveResponse from '../../TicketDetailComponents/SubComponents/PositiveResponse';
// import TicketAction from '../../TicketDetailComponents/SubComponents/TicketAction';
import { sortTicketsByDate } from '../../../utils/helpers';
// import ascendingIcon from '../../../../assets/icons/ascending-icon.svg';
// import descendingIcon from '../../../../assets/icons/descending-icon.svg';
import './style.scss';

const ArchiveSearchResults = ({ tickets, token }) => {
  const { state } = useContext(Store);
  const { selectedMatch } = state;
  const [isDescending, setIsDescending] = useState(true);
  const [sortedTickets, setSortedTickets] = useState(tickets);

  useEffect(() => {
    if (Object.keys(tickets).length > 0) {
      setSortedTickets(sortTicketsByDate(tickets, isDescending));
    } else {
      setSortedTickets({});
    }
  }, [tickets, isDescending]);

  return (
    <div className={'results-container'}>
      <div className={'results'}>
        {Object.keys(sortedTickets).length > 0 && (
          <button
            className="sort-button"
            onClick={() => {
              setIsDescending(!isDescending);
            }}
          >
            {/* <img
              src={isDescending ? descendingIcon : ascendingIcon}
              alt="sortIcon"
            /> */}
            <span>{isDescending ? 'Descending' : 'Ascending'}</span>
          </button>
        )}
        {Object.keys(sortedTickets).map(matchingTicket => {
          const ticket = sortedTickets[matchingTicket];
          return <MatchingTicketSection key={matchingTicket} ticket={ticket} id={matchingTicket} />;
        })}
      </div>
      {selectedMatch && (
        <div className={'details-container'}>
          {selectedMatch?.result?.docType === 'ticket' ? (
            <>
              {selectedMatch?.result?.legacyTicket && (
                <a
                  href={`https://www.irth.com/Utilisphere/TicketManager/ViewTicket.aspx?ID=${selectedMatch.result.legacyTicket.UtiliSphereID}`}
                  target={'_blank'}
                  rel={'noopener noreferrer'}
                >
                  link to legacy ticket in IRTH
                </a>
              )}
              <ArchiveDetails ticket={selectedMatch.result} />
              <Inspector data={selectedMatch} />
            </>
          ) : selectedMatch?.result?.docType === 'workLog' ? (
            <>
              <WorkLog worklog={selectedMatch.result} />
              <Inspector data={selectedMatch} />
            </>
          ) : selectedMatch?.result?.docType === 'positiveResponse' ? (
            <>
              <PositiveResponse positiveResponse={selectedMatch.result} />
              <Inspector data={selectedMatch} />
            </>
          ) : selectedMatch?.result?.docType ? (
            <>
              <div>Unknown document type: {selectedMatch.result.docType}</div>
              <Inspector data={selectedMatch} />
            </>
          ) : null}
        </div>
      )}
    </div>
  );
};

ArchiveSearchResults.propTypes = {
  tickets: PropTypes.object.isRequired,
  token: PropTypes.string.isRequired,
};

export default ArchiveSearchResults;
